export const addresses = {
  svgHelperAddress: "0xAD2935E147b61175D5dc3A9e7bDa93B0975A43BA",
  providerAddress: "0x00CAC06Dd0BB4103f8b62D280fE9BCEE8f26fD59",
  sampleToken: "0x4951A1C579039EbfCBA0BE33D2cd3A6D30b0f802",
};
